import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { IntlProvider } from 'react-intl';

import en_GB from './_locale/en-GB.json';
import { GraphQLContainer } from './containers/graphql-container/graphql.container';
import { RouterContainer } from './core/routing';

import { ErrorBoundary } from 'react-error-boundary';
import { ErrorRender } from './app.error';
import { DialogContainer } from './containers/dialog-container/dialog-container.component';
import { ToastContainer } from './containers/toast-container/toast.container';

type AppProps = {
  instance: PublicClientApplication;
};

const App = ({ instance }: AppProps) => {
  return (
    <ErrorBoundary fallbackRender={ErrorRender}>
      <MsalProvider instance={instance}>
        <IntlProvider
          locale="en-GB"
          messages={{
            ...en_GB,
          }}
        >
          <GraphQLContainer>
            <RouterContainer />
            <DialogContainer />
            <ToastContainer />
          </GraphQLContainer>
        </IntlProvider>
      </MsalProvider>
    </ErrorBoundary>
  );
};

export default App;
